import { render, staticRenderFns } from "./SupportNetwork.vue?vue&type=template&id=bfa40996&scoped=true"
import script from "./SupportNetwork.vue?vue&type=script&lang=ts"
export * from "./SupportNetwork.vue?vue&type=script&lang=ts"
import style0 from "./SupportNetwork.vue?vue&type=style&index=0&id=bfa40996&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa40996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa40996')) {
      api.createRecord('bfa40996', component.options)
    } else {
      api.reload('bfa40996', component.options)
    }
    module.hot.accept("./SupportNetwork.vue?vue&type=template&id=bfa40996&scoped=true", function () {
      api.rerender('bfa40996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/SupportNetwork.vue"
export default component.exports